import { Link } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useBugReports } from '@/hooks/useBugReports';
import { useChangeRequests } from '@/hooks/useChangeRequests';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { Bug, Lightbulb } from 'lucide-react';

export function AdminBadge() {
  const { isAdmin } = useIsAdmin();
  const { newCount: bugNewCount } = useBugReports();
  const { newCount: changeNewCount } = useChangeRequests();

  if (!isAdmin) return null;

  const totalNewCount = bugNewCount + changeNewCount;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Inbox className="h-5 w-5" />
          {totalNewCount > 0 && (
            <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-destructive-foreground text-xs flex items-center justify-center font-medium">
              {totalNewCount > 9 ? '9+' : totalNewCount}
            </span>
          )}
          <span className="sr-only">Feedback</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <Link to="/admin/bugs" className="flex items-center gap-2">
            <Bug className="h-4 w-4" />
            Bug Reports
            {bugNewCount > 0 && (
              <span className="ml-auto text-xs bg-destructive text-destructive-foreground px-1.5 py-0.5 rounded-full">
                {bugNewCount}
              </span>
            )}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/admin/changes" className="flex items-center gap-2">
            <Lightbulb className="h-4 w-4" />
            Change Requests
            {changeNewCount > 0 && (
              <span className="ml-auto text-xs bg-destructive text-destructive-foreground px-1.5 py-0.5 rounded-full">
                {changeNewCount}
              </span>
            )}
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
